import type { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { ALLOWED_IMG_TYPES, UPLOAD_MAX_FILESIZE } from '@/constants';
import { snackbarColor } from '@/enums';
import { useSnackbar } from '@/hooks';

export const useCheckFileType = () => {
    const { t } = useTranslation();
    const showSnackbar = useSnackbar();

    const checkFileType = (file: File | Blob, callback: () => void) => {
        const check = ALLOWED_IMG_TYPES.split(',')
            .map(t => t.replace('.', 'image/').trim())
            .includes(file.type);

        if (check) {
            callback();
        } else {
            showSnackbar({
                open: true,
                message: t('message.error-image-formate'),
                severity: snackbarColor.error,
            });
        }
    };

    const checkFileDocx = (file: File | Blob) => {
        const check = file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        if (!check) {
            showSnackbar({
                open: true,
                message: t('message.error-docx-format'),
                severity: snackbarColor.error,
            });
        }
        return check;
    };

    const checkFile = (e: ChangeEvent<HTMLInputElement>, callback: (file: File) => void) => {
        const file = e.target.files?.[0];
        if (file) {
            e.currentTarget.value = '';
            if (file.size / 1e6 > UPLOAD_MAX_FILESIZE) {
                showSnackbar({
                    open: true,
                    message: t('verifyed-upload', { size: UPLOAD_MAX_FILESIZE }),
                    severity: snackbarColor.error,
                });
            } else {
                checkFileType(file, () => {
                    callback(file);
                });
            }
        }
    };

    return { checkFileType, checkFileDocx, checkFile };
};
